import { t } from 'i18next';
import { CorrectiveInvoiceLinesHeadCell } from './CorrectiveInvoiceLines.types';

export const correctiveInvoiceLinesHeadCells: CorrectiveInvoiceLinesHeadCell[] =
  [
    {
      id: 'index',
      numeric: false,
      label: '#',
      align: 'left',
    },
    {
      id: 'code',
      numeric: true,
      label: t('activity', { ns: 'invoice' }),
      align: 'left',
    },
    {
      id: 'quantity',
      numeric: true,
      label: t('amount', { ns: 'misc' }),
      align: 'left',
    },
    {
      id: 'unitCode',
      numeric: true,
      label: t('unit', { ns: 'invoice' }),
      align: 'left',
    },
    {
      id: 'currencyAmount',
      numeric: true,
      label: t('price', { ns: 'invoice' }),
      align: 'right',
    },
    {
      id: 'currency',
      numeric: true,
      label: t('currency', { ns: 'currency' }),
      align: 'justify',
    },
    {
      id: 'exchangeRate',
      numeric: true,
      label: t('exchangeRate', { ns: 'invoice' }),
      align: 'right',
    },
    {
      id: 'netValue',
      numeric: true,
      label: t('netValue', { ns: 'invoice' }),
      align: 'right',
    },
    {
      id: 'taxRate',
      numeric: true,
      label: t('taxRate', { ns: 'invoice' }),
      align: 'right',
    },
    {
      id: 'taxValue',
      numeric: true,
      label: t('taxValue', { ns: 'invoice' }),
      align: 'right',
    },
    {
      id: 'grossValue',
      numeric: true,
      label: t('grossValue', { ns: 'invoice' }),
      align: 'right',
    },
  ];
